import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

import as from 'axios'

Vue.prototype.$axios = as

// import { Lazyload } from 'vant';
// Vue.use(Lazyload);
// // 注册时可以配置额外的选项
// Vue.use(Lazyload, {
//   lazyComponent: true,
// });

new Vue({
  render: h => h(App),
  router

}).$mount('#app')
